import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Insurance } from '../_models/insurance';
import { environment } from '../../../environments/environment';

@Injectable()
export class InsuranceService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getInsurances(): Observable<Insurance[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/insurances')
      .pipe(map((response) => response));
  }

  getInsurance(id: number): Observable<Insurance> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/insurances/' + id)
      .pipe(map((response) => response));
  }

  saveInsurance(insuranceItem): Observable<Insurance> {
    const insurance = { ...insuranceItem };
    delete insurance.lastUpdated;
    delete insurance.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    insurance.companyId = companySelected ? companySelected.id : null;

    if (insurance.user != null && insurance.user.id != null) {
      insurance.user = { id: insurance.user.id };
    }
    if (insurance.id) {
      return this.http
        .put<Insurance>(this.apiBaseUrl + 'api/private/v1/insurances/' + insurance.id, insurance)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Insurance>(this.apiBaseUrl + 'api/private/v1/insurances/', insurance)
        .pipe(map((response) => response));
    }
  }

  deleteInsurance(id: number): Observable<Insurance> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/insurances/' + id).pipe(
      map((response) => {
        return { id } as Insurance;
      })
    );
  }
}
